import { Platforms } from '@twa-dev/types'
type HomeScreenCompatiblePlatforms = Exclude<Platforms, 'macos' | 'tdesktop' | 'unknown'>
export function isHomeScreenCompatible(platform: Platforms): platform is HomeScreenCompatiblePlatforms {
  return ['android', 'android_x', 'ios', 'weba', 'webk', 'unigram'].includes(platform)
}
